/**
 * Короткі підписи складів для дашборда.
 *
 * Ключі — `Location` з `backend/apps/stock/models.py`. Підписи вкорочені під
 * вузькі колонки дашборда; повні назви складів живуть у `WarehouseNav`.
 */
const LOCATION_LABELS: Record<string, string> = {
  external: 'Постачальник',
  // Кругляк додався пізніше за решту складів, і ці два підписи забули —
  // у стрічці замість назви світився сирий код `round_stock`.
  round_stock: 'Склад кругляка',
  in_sawing: 'Розпил',
  predrying: 'Підсушна',
  in_drying: 'Сушіння',
  in_processing: 'Переробка',
  dry_stock: 'Склад сухої',
  blank_stock: 'Склад ЧЗ',
  product_stock: 'Склад ГП',
  waste: 'Склад відходів',
  prep_shop: 'Загот. цех',
  firewood: 'Склад дров',
};

/** Назви рядків у блоці «Залишки по складах» — як у прототипі. */
export const STOCK_ROW_LABELS: Record<string, string> = {
  predrying: 'Підсушна дільниця',
  in_drying: 'У сушінні',
  dry_stock: 'Склад сухої деревини',
  prep_shop: 'Заготівельний цех',
  in_processing: 'У переробці',
  blank_stock: 'Чорнові заготовки',
  product_stock: 'Склад готової продукції',
};

export function locationLabel(key: string): string {
  return LOCATION_LABELS[key] ?? key;
}
